import React, { useState } from 'react';
import { FaEye, FaCheckCircle, FaClock, FaTimes } from 'react-icons/fa';
import { NavBarAdm } from '../Components/NavBarAdm'; // Asegúrate de importar tu navbar
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

function UserNoVerificated() {
  // Datos ficticios
  const [users] = useState([
    {
      id: 1,
      name: 'María',
      lastName: 'González',
      phone: '+584121234567',
      correo: 'liliafinol@gmail.com',
      verif: 'N',
    },
    {
      id: 2,
      name: 'Pedro',
      lastName: 'Martínez',
      phone: '+584141234567',
      correo: 'liliafinol@gmail.com',
      verif: 'N',
    },
    {
      id: 3,
      name: 'Ana',
      lastName: 'Pérez',
      phone: '+584125556677',
      correo: 'liliafinol@gmail.com',
      verif: 'N',
    },
  ]);

  const [searchQuery, setSearchQuery] = useState('');
  const [selectedUser, setSelectedUser] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const filteredUsers = users.filter((user) =>
    `${user.name} ${user.lastName} ${user.dni}`.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const getVerificationIcon = (status) => {
    if (status === 'S') return <FaCheckCircle color="#178f6b" />;
    if (status === 'E') return <FaClock color="#c59100" />;
    if (status === 'N') return <FaTimes color="#d94343" />;
  };

  return (
    <div className="users-page">

      <h2 className="section-title">Usuarios No Verificados</h2>

      <div className="users-actions">
        <input
          type="text"
          placeholder="Buscar por nombre, apellido o DNI"
          className="search-input"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      <div className="users-table-wrapper">
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Nombre</th>
              <th>Apellido</th>
              <th>Teléfono</th>
              <th>Email</th>
              <th>Verificación</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {filteredUsers.map((user, idx) => (
              <tr key={user.id}>
                <td>{idx + 1}</td>
                <td>{user.name}</td>
                <td>{user.lastName}</td>
                <td>{user.phone}</td>
                <td>{user.correo}</td>
                <td>{getVerificationIcon(user.verif)}</td>
                <td>
                  <FaEye
                    className="view-details-icon"
                    onClick={() => {
                      setSelectedUser(user);
                      setShowModal(true);
                    }}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modal de detalles */}
      {selectedUser && (
        <Modal centered isOpen={showModal} toggle={() => setShowModal(false)}>
          <ModalHeader toggle={() => setShowModal(false)}>
            Detalles de {selectedUser.name} {selectedUser.lastName}
          </ModalHeader>
          <ModalBody>
            <p><strong>Teléfono:</strong> {selectedUser.phone}</p>
            <p><strong>DNI:</strong> {selectedUser.dni}</p>
            <p><strong>Estado:</strong> No Verificado</p>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => setShowModal(false)}>
              Cerrar
            </Button>
          </ModalFooter>
        </Modal>
      )}
      < NavBarAdm />
    </div>
  );
}

export { UserNoVerificated };
